import { useMutation, useQuery, useQueryClient } from "react-query";
import { useApiService } from "../useApiService";
import { UserRatingControllerService } from "../../services";
import { QUERY } from "../../constants/query";

export const useCreateFeedback = () => {
  const { handleRequest } = useApiService();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({
      userId,
      vastuRemedyId,
      requestBody,
    }: {
      requestBody: {
        rating: number;
        comment: string;
      };
      userId: string;
      vastuRemedyId: string;
    }) =>
      handleRequest(
        UserRatingControllerService.userRatingControllerCreateUserRating(
          userId,
          vastuRemedyId,
          requestBody
        )
      ),
    {
      onSuccess: (response) => {
        console.log("Property created successfully:", response);
        queryClient.invalidateQueries(QUERY.CHECK_FEEDBACK_EXISTS);
      },
    }
  );

  return {
    ...mutation,
  };
};

export const useCheckFeedBackExists = (remedyId: string) => {
  const { handleRequest } = useApiService();
  const queryKey = [QUERY.CHECK_FEEDBACK_EXISTS, remedyId];

  const query = useQuery(
    queryKey,
    () =>
      handleRequest(
        UserRatingControllerService.userRatingControllerCheckFeedBackExists(
          remedyId
        )
      ),
    {
      enabled: !remedyId || !!remedyId,
    }
  );

  return {
    ...query,
  };
};
